define(['jquery', 'c21/maps/PropertyPaginator', 'c21/maps/TooltipManager', 'c21/viewSession', 'c21/lazy'], function ($, PropertyPaginator, TooltipManager, viewSession, lazy) {
   "use strict";

   return function (map) {
      var self = this,

         m_iPinHeight = 35,
         m_iTooltipPadding = 20,
         m_iYOffset = -m_iPinHeight - m_iTooltipPadding,

         m_map = map,
         m_jHoverTemplate = $("<div class='hoverOverlay propertySummaryHoverOverlay'><div class='contentTip'></div></div>"),
         m_jClickTemplate = $("<div class='clickOverlay propertySummaryClickOverlay'><div class='contentTip'></div></div>"),
         initClickTooltip = function (jTooltip, pinData) {
            new PropertyPaginator(jTooltip);
            m_jClickTemplate.find(".mapToolTipClose").click(m_tooltipManager.hideClickTooltip);
            lazy.loadIn(m_jClickTemplate.find(".photoLink"));
         },
         m_tooltipManager = new TooltipManager(m_map, {
            hoverTemplate: m_jHoverTemplate,
            clickTemplate: m_jClickTemplate,
            initClickTooltip: initClickTooltip,
            getClickHtml: function (pinData) {
               return $.Deferred(function (dfd) {
                  var strLid = pinData.getId(),
                     jOnPage = $("#propertySummaryClickOverlay_" + strLid),
                     brandCd = jOnPage.data('brandcd'),
                     sourceId = jOnPage.data('sourceid');

                  if(brandCd === 'C21' && websiteCode == 'ECO_COMM') { // Golden Ruler Tracking
                    // grtrack({activity: 'view_bubble', guid: sourceId});
                  }

                  // Clear out previous price information
                  m_jClickTemplate.find('.contentTip').empty();

                  //Added this code to clear out the favorite selection from a previous div and set the new favorite
                  // TODO: Use ID selector
                  var jOverlay = $('.propertySummaryClickOverlay').removeClass('favorite');
                  viewSession.setFavoriteProperty(jOverlay, strLid);

                  dfd.resolve(jOnPage.html());
               }).promise();
            },
            getHoverHtml: function (pinData) {
               return $.Deferred(function (dfd) {
                  var strLid = pinData.getId(),
                     jOnPage = $("#propertySummaryHoverOverlay_" + strLid);

                  dfd.resolve(jOnPage.html());
               }).promise();
            },
            hoverOffset: {
               x: 0,
               y: m_iYOffset,
               tip: -4
            },
            clickOffset: {
               x: 3,
               y: m_iYOffset + 29,
               tip: -4
            }
         }),
         initialize = function () {};

      self.showClickTooltip = m_tooltipManager.showClickTooltip;
      self.showHoverTooltip = m_tooltipManager.showHoverTooltip;
      self.hideHoverTooltip = m_tooltipManager.hideHoverTooltip;
      self.hideTooltipByPinData = m_tooltipManager.hideTooltipByPinData;
      self.clear = m_tooltipManager.clear;

      initialize();
   };
});
